var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"type":"text","label":"Name"},on:{"change":_vm.handleNameUpdate,"keyup":_vm.handleNameUpdate},model:{value:(_vm.nameValue),callback:function ($$v) {_vm.nameValue=$$v},expression:"nameValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }